import { type PayloadAction, createSlice } from "@reduxjs/toolkit"

import { logout } from "../../containers/LoginPage/redux/auth.thunks"
import { type NavState } from "./nav.types.ts"

const initialState: NavState = {
  isDesktop: false,
  isMobile: false,

  isSidebarOpen: true,
  isMobileMenuOpen: false,

  disabledTransition: false
}

const navSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    navSetProp: {
      reducer: (
        state,
        action: PayloadAction<{
          key: keyof NavState
          value: NavState[keyof NavState]
        }>
      ) => {
        const { key, value } = action.payload
        state[key] = value
      },
      prepare: <K extends keyof NavState>(key: K, value: NavState[K]) => ({
        payload: { key, value }
      })
    },
    setIsDesktop: (state, action) => {
      state.isDesktop = action.payload
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload
    },

    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen
    },
    toggleSideBar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => {
      console.log("nav logout")
      return initialState
    })
  }
})

export const {
  navSetProp,
  setIsDesktop,
  setIsMobile,
  toggleSideBar,
  toggleMobileMenu
} = navSlice.actions

export default navSlice
